<template>
	<div>
		<v-date-picker
			:mode="mode"
			v-model="selectedDate"
			:modelConfig="{
                type: 'string',
                mask: mask,
            }"
			:is24hr="mode === 'datetime' || mode === 'dateTime'"
			:is-required="isRequired"
			:popover="popover"
			:min-date="minDate"
			@update:modelValue="update"
		>
			<template v-slot="{ inputValue, showPopover, inputEvents }">
				<label class="block w-full relative">
					<svg-icon icon="calendar2"
							  class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-blue-500"></svg-icon>

					<input
						class="input fc-input pl-10 w-full datepicker-input"
						:value="inputValue"
						:placeholder="placeholder"
						:disabled="disabled"
						:autocomplete="autocomplete"
						v-on="inputEvents"
					>

					<input type="hidden" :name="name" v-model="selectedDate">
				</label>
			</template>
		</v-date-picker>
	</div>
</template>
<script>
import {DatePicker} from "v-calendar";
import SvgIcon from "../partials/SvgIcon.vue";

export default {
	props: [
		'mode',
		'value',
		'modelValue',
		'name',
		'placeholder',
		'disabled',
		'autocomplete',
		'isRequired',
		'minDate',
	],
	components: {
		SvgIcon,
		'v-date-picker': DatePicker,
	},
	data() {
		return {
			popover: {
				visibility: 'focus'
			},
			selectedDate: this.value ?? this.modelValue,
		};
	},
	updated() {
		this.selectedDate = this.value ?? this.modelValue;
	},
	computed: {
		mask() {
			if (this.mode === 'datetime' || this.mode === 'dateTime') {
				return 'YYYY-MM-DD HH:mm';
			}

			if (this.mode === 'time') {
				return 'HH:mm:ss';
			}

			return 'YYYY-MM-DD'
		},
	},
	methods: {
		update(value) {
			this.$emit('update:modelValue', this.formatDate(new Date(value)));
		},
		formatDate(date) {
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');

			if (this.mode === 'datetime' || this.mode === 'dateTime') {
				return `${year}-${month}-${day} ${hour}:${minutes}`;
			}

			if (this.mode === 'time') {
				return `${hour}:${minutes}:${seconds}`;
			}

			return `${year}-${month}-${day}`;
		}
	},
}
</script>
